import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    ServiceCenterFormType,
} from '../serviceCenters.types'

const getWorkScheduleFields = ({
    isLunchBreak,
}: {
    isLunchBreak: boolean,
}): DTOCardFormField<keyof ServiceCenterFormType>[] => {
    return [{
        id: 'operationalDays',
        title: 'Operational Days',
        className: 'operationalDays',
        fields: [
            {
                name: 'operationalHours',
                componentName: 'OperationalDays',
                className: 'operationalHours',
                labelKey: '',
            },
            {
                name: 'isLunchBreak',
                componentName: 'Checkbox',
                className: 'isLunchBreak',
                labelKey: 'ServiceCenter.isLunchBreak',
            },
            {
                name: 'breakStartsAt',
                componentName: 'TimePicker',
                disabled: !isLunchBreak,
                required: isLunchBreak,
                labelKey: 'ServiceCenter.workStartsAt',
            },
            {
                name: 'breakEndsAt',
                componentName: 'TimePicker',
                disabled: !isLunchBreak,
                required: isLunchBreak,
                labelKey: 'ServiceCenter.workEndsAt',
            },
        ],
    }]
}

export default getWorkScheduleFields
